<template>
  <div>
    <page-header
      title="Account Settings"
      breadcrumb="Dashboard >> Settings >> Account Settings"
    />
    <div class="flex justify-between mt-12 mb-2">
      <div class="flex">
        <div
          class="tab-item"
          :class="{ active: currentTab == 'profile-info' }"
          @click="currentTab = 'profile-info'"
        >
          <p>Profile Info</p>
        </div>
        <div
          class="tab-item"
          :class="{ active: currentTab == 'security' }"
          @click="currentTab = 'security'"
        >
          <p>Security</p>
        </div>
        <div 
          class="tab-item"
          :class="{ active: currentTab == 'others' }"
          @click="currentTab = 'others'"
        >
          <p>Others</p>
        </div>
      </div>
    </div>
    <hr />
    <keep-alive>
      <component :is="currentTab"></component>
    </keep-alive>
  </div>
</template>

<script>
import PageHeader from "@/components/UI/NewPageHeader";
import ProfileInfo from "./Tabs/ProfileInfo";
import Others from "./Tabs/Others";
import Security from "./Tabs/Security";
export default {
  components: {
    Security,
    Others,
    ProfileInfo,
    PageHeader,
  },
  data() {
    return {
      currentTab: "profile-info",
      query: "",
      count: {},
    };
  },
  watch: {
    currentTab(val) {
      this.$store.dispatch("setCurrentUsersAndGroupTab", val);
    },
  },
  mounted() {
    this.currentTab = "profile-info"
  },
  methods: {
    showDeleteModal(payload) {
      this.itemToDelete = payload[0];
      this.selectedId = payload[1];
      this.isDeleteModal = true;
    },
    async deleteUser() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteUser(this.selectedId);
        this.onDeleteUser(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    async deleteGroup() {
      this.deletingItem = true;
      try {
        let response = await this.$_deleteGroup(this.selectedId);
        this.onDeleteGroup(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    onDeleteUser(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;
      this.$refs.usersDataTable.getAllUsers();
      this.generateToast("User successfully deleted!", "success");
    },
    onDeleteGroup(response) {
      console.log(response);
      this.isDeleteModal = false;
      this.deletingItem = false;

      this.$refs.groupsDataTable.getAllGroups();
      this.generateToast("Group successfully deleted!", "success");
    },
    deleteItem() {
      if (this.itemToDelete == "User") {
        this.deleteUser();
      } else if (this.itemToDelete == "Group") {
        this.deleteGroup();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  cursor: pointer;

  color: #5e646d;
  padding: 0.5rem 1.5rem;
  font-size: 0.9rem;
  &.active {
    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(17, 21, 25, 0.1);
    border-radius: 5px;
    color: #fcc210;
    font-weight: bold;
  }
}
</style>
